import { useGlobalStore } from "@/store/GlobalStore";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { message } from "antd";
import { useForm } from "antd/lib/form/Form";
import { TransferItem } from "antd/lib/transfer";
import { useState, useRef } from "react";
import ProjectAPI from "../api";
import { ParamsType } from "../components/add-or-edit-project-drawer";
import { useProjectStore } from "../store/project-store";
import { IProjectForm, IUser, Project, ITransferProps } from "../types";
import {
  removeDataByValue,
  getObjectValue,
  setObjectValue,
  makeUpSubmitArr,
  getObjectAllValues,
} from "../helper";

const initParams = {
  renderNum: 1,
  taskOverTime: 12,
  munuTaskOverTime: 24,
};
export function useEditProject() {
  const t = getTranslateNsT("center");
  const { userInfo, isSubAccount } = useGlobalStore();
  const [dataSource, setDataSource] = useState<TransferItem[]>([]);
  const [targetKeys, setTargetKeys] = useState<ITransferProps[]>([]);
  const [projectForm] = useForm<IProjectForm>();
  const {
    fetchProjectData,
    subDingtalkDatas,
    originDingTalkData,
    setSubDingtalkDatas,
    setOriginDingTalkData,
  } = useProjectStore();
  const [open, setOpen] = useState(false);
  const subDingtalkDatasyRef = useRef(subDingtalkDatas);
  const [params, setParams] = useState<any>({
    renderNum: 1,
    taskOverTime: 12,
    munuTaskOverTime: 24,
  });
  const onStateChange = (state: boolean) => {
    setOpen(state);
    if (!state) {
      projectForm.resetFields();
      setParams(initParams);
    }
  };
  const handleRemoveChange = ({
    text,
    id,
    isDingTalkOriganize,
    deptId,
  }: {
    text: string;
    id: string;
    isDingTalkOriganize?: boolean;
    deptId?: any;
  }) => {
    setTargetKeys(targetKeys.filter((item) => item.id !== id));
    if (isDingTalkOriganize) {
      if (!deptId || !Array.isArray(deptId)) return;
      subDingtalkDatasyRef.current = subDingtalkDatas;
      deptId.forEach((item: string | number) => {
        const result = getObjectValue(
          JSON.parse(JSON.stringify(originDingTalkData)),
          ["id", "realDeptId"],
          [id, item]
        );
        const finishData = setObjectValue(
          JSON.parse(JSON.stringify(subDingtalkDatasyRef.current)),
          "deptId",
          item,
          result
        );
        subDingtalkDatasyRef.current = finishData;
      });
      setSubDingtalkDatas(subDingtalkDatasyRef.current);
      return;
    }
    setDataSource([
      ...dataSource,
      ...[
        {
          key: text,
          title: text,
          description: id ?? "",
        },
      ],
    ]);
  };
  const onSelectChange = (sourceSelectedKeys: ITransferProps[]) => {
    const { isDingTalkOriganize, ...result } = sourceSelectedKeys[0];
    if (!result.id) return;
    if (isDingTalkOriganize) {
      const targetKey = Array.from(
        new Set(
          getObjectAllValues(subDingtalkDatas, "id", result.id, "realDeptId")
        )
      );
      sourceSelectedKeys[0].deptIdList = targetKey as number[];
      const finishData = removeDataByValue(subDingtalkDatas, "id", result.id);
      setSubDingtalkDatas(finishData);
    } else {
      setDataSource(
        dataSource.filter((item) => item.description !== result.id)
      );
    }
    setTargetKeys([...targetKeys, ...sourceSelectedKeys]);
  };
  const onOpen = async (projectName: string, users: IUser[]) => {
    onStateChange(true);
    const { data } = await ProjectAPI.queryLabelUser({
      label: projectName,
    });
    if (!data) return;
    const targetKeysTemp = data
      .filter(
        (item: any) =>
          item.userName !== userInfo?.userName && item.isSelect === "1"
      )
      .map((item: any) => {
        return {
          id: item.userId,
          text: item.userName,
          isDingTalkOriganize: item.isDingTalk,
          deptIdList: item.deptIdList,
        };
      });

    const dataSourceTemp = data
      .filter(
        (item: any) =>
          item.userName !== userInfo?.userName &&
          item.isSelect === "0" &&
          !item.isDingTalk
      )
      .map((item: any) => ({
        key: item.userName,
        title: item.userName,
        description: item.userId,
      }));

    const { data: result = [] } = await ProjectAPI.queryDingTalkDeptByUser();
    setOriginDingTalkData(makeUpSubmitArr(result));
    setSubDingtalkDatas(result);
    subDingtalkDatasyRef.current = result;
    const dingTalkData = data.filter(
      (item: IUser) => item.isSelect === "1" && item.isDingTalk
    );
    dingTalkData.forEach((item: IUser) => {
      const finishData = removeDataByValue(
        subDingtalkDatasyRef.current,
        "id",
        +item.userId
      );
      subDingtalkDatasyRef.current = finishData;
    });
    setSubDingtalkDatas(subDingtalkDatasyRef.current);
    setTargetKeys(targetKeysTemp);
    setDataSource(dataSourceTemp);
    setOpen(true);
  };
  const onEdit = (row: Project.Info) => {
    const submitParams: any = {
      renderNumStatus: 0,
      taskOverTimeStatus: 0,
      munuTaskOverTimeStatus: 0,
      ...projectForm.getFieldsValue(),
    };
    submitParams.paramsLocked?.map((item: string) => {
      submitParams[item] =
        item === ParamsType.RenderNum ? +params[item] : params[item] * 3600;
      submitParams[item + "Status"] = 1;
      return item;
    });
    submitParams.ids = targetKeys.map((item) => item.id);
    submitParams.label = row.projectName;
    submitParams.modifiedLabel = submitParams.newName;
    delete submitParams.paramsLocked;
    delete submitParams.newName;
    projectForm
      .validateFields()
      .then(() => {
        ProjectAPI.editProject({
          ...submitParams,
          projectId: row.projectId,
        }).then((res) => {
          if (res.result) {
            message.success(t("user_com_childPro_msg_add_success"));
            onStateChange(false);
            fetchProjectData();
          }
          if (res.code === 503) {
            message.error(t("render_project_name_not_same"));
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return {
    userInfo,
    isSubAccount,
    onSelectChange,
    onOpen,
    dataSource,
    setDataSource,
    targetKeys,
    setTargetKeys,
    open,
    onEdit,
    onStateChange,
    projectForm,
    params,
    setParams,
    handleRemoveChange,
  };
}
